import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import { SpotForContentsEditFragmentDoc } from '../../../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetSpotQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetSpotQuery = { __typename?: 'QueryRoot', spot: { __typename?: 'Spot', id: string, parentSpotId?: string | null, spotType: Types.SpotType, order: number, name?: string | null, description?: string | null, geofenceRadius: number, narrationText?: string | null, hasCafe: boolean, hasRestroom: boolean, hasPaidParking: boolean, hasFreeParking: boolean, hasRestaurant: boolean, hasEvCharger: boolean, musicQuestion?: string | null, narrationTextForTtsBeforeMusic?: string | null, narrationTextForTtsAfterMusic?: string | null, note?: string | null, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } } };

export type UpdateSpotMutationVariables = Types.Exact<{
  input: Types.UpdateSpotInput;
}>;


export type UpdateSpotMutation = { __typename?: 'MutationRoot', updateSpot: { __typename?: 'Spot', id: string, name?: string | null } };

export type GetTextToSpeechAudioQueryVariables = Types.Exact<{
  narration: Types.Scalars['String'];
}>;


export type GetTextToSpeechAudioQuery = { __typename?: 'QueryRoot', textToSpeechEncodedAudio: { __typename?: 'TextToSpeechEncodedAudioPayload', encodedAudio: string } };


export const GetSpotDocument = gql`
    query GetSpot($id: String!) {
  spot(id: $id) {
    ...SpotForContentsEdit
  }
}
    ${SpotForContentsEditFragmentDoc}`;

export function useGetSpotQuery(options: Omit<Urql.UseQueryArgs<GetSpotQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSpotQuery, GetSpotQueryVariables>({ query: GetSpotDocument, ...options });
};
export const UpdateSpotDocument = gql`
    mutation UpdateSpot($input: UpdateSpotInput!) {
  updateSpot(input: $input) {
    id
    name
  }
}
    `;

export function useUpdateSpotMutation() {
  return Urql.useMutation<UpdateSpotMutation, UpdateSpotMutationVariables>(UpdateSpotDocument);
};
export const GetTextToSpeechAudioDocument = gql`
    query GetTextToSpeechAudio($narration: String!) {
  textToSpeechEncodedAudio(inputText: $narration) {
    encodedAudio
  }
}
    `;

export function useGetTextToSpeechAudioQuery(options: Omit<Urql.UseQueryArgs<GetTextToSpeechAudioQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTextToSpeechAudioQuery, GetTextToSpeechAudioQueryVariables>({ query: GetTextToSpeechAudioDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSpotQuery((req, res, ctx) => {
 *   const { id } = req.variables;
 *   return res(
 *     ctx.data({ spot })
 *   )
 * })
 */
export const mockGetSpotQuery = (resolver: ResponseResolver<GraphQLRequest<GetSpotQueryVariables>, GraphQLContext<GetSpotQuery>, any>) =>
  graphql.query<GetSpotQuery, GetSpotQueryVariables>(
    'GetSpot',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSpotMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateSpot })
 *   )
 * })
 */
export const mockUpdateSpotMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateSpotMutationVariables>, GraphQLContext<UpdateSpotMutation>, any>) =>
  graphql.mutation<UpdateSpotMutation, UpdateSpotMutationVariables>(
    'UpdateSpot',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetTextToSpeechAudioQuery((req, res, ctx) => {
 *   const { narration } = req.variables;
 *   return res(
 *     ctx.data({ textToSpeechEncodedAudio })
 *   )
 * })
 */
export const mockGetTextToSpeechAudioQuery = (resolver: ResponseResolver<GraphQLRequest<GetTextToSpeechAudioQueryVariables>, GraphQLContext<GetTextToSpeechAudioQuery>, any>) =>
  graphql.query<GetTextToSpeechAudioQuery, GetTextToSpeechAudioQueryVariables>(
    'GetTextToSpeechAudio',
    resolver
  )
